export default "__VITE_ASSET__PK31Dc3O__"